export default async function(db, query, aid, content) {
  const { update, updateId } = query;
  if (update === 'invoice' && updateId) {
    try {
      return await db.doc(`accounts/${aid}/invoices/${updateId}`).update(content);
    } catch (error) {
      console.log('failed side update', error);
    }
  }
}
